import React, { useRef, useState } from "react";
import {
  Button,
  Checkbox,
  Container,
  Form,
  Grid,
  Icon,
  Message,
  Segment,
} from "semantic-ui-react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Col, Row, Image } from "react-bootstrap";
import { DatePicker } from "antd";
import defImage from "../../../assets/images/image.png";

function PersonalInfoForm({ next }) {
  const [checked, setChecked] = useState(false);
  const [newUser, setUser] = useState({
    firstName: "",
    lastName: "",
    dob: "",
    phone: "",
    address: "",
    image: "",
    imageUrl: "",
  });
  const [errors, setErrors] = useState({
    firstName: false,
    lastName: false,
    phone: false,
    address: false,
    response: { show: false, type: "success", message: "" },
  });
  const [loading, setLoading] = useState(false);
  const [loadImage, setLoadImage] = useState(false);
  const uploader = useRef(null);

  const handleSignup = async () => {
    try {
      const { firstName, lastName, dob, phone, address, imageUrl } = newUser;
      const userAccount = JSON.parse(localStorage.getItem("user"));
      if (!newUser.firstName) return setErrors({ ...errors, firstName: true });
      if (!newUser.lastName) return setErrors({ ...errors, lastName: true });
      if (!newUser.address) return setErrors({ ...errors, address: true });

      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/signup/web`,
        {
          firstName,
          lastName,
          dob,
          phone,
          address,
          image: imageUrl,
          ...userAccount,
        }
      );
      setLoading(false);
      if (response.status === 201) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "success",
            message: "User successfully created!",
          },
        });
        setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
        localStorage.removeItem("user");
        localStorage.setItem("newToken", response.data.data.token);
        return next();
      }
    } catch (error) {
      setLoading(false);
      if (error.message === "Network Error") {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.message,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 400) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      // if (error.response.status === 409) {
      //   setErrors({
      //     ...errors,
      //     response: {
      //       show: true,
      //       type: "error",
      //       message: error.response.data.error,
      //     },
      //   });
      //   return setTimeout(
      //     () => setErrors({ ...errors, response: { show: false } }),
      //     3000
      //   );
      // }
      setErrors({
        ...errors,
        response: {
          show: true,
          type: "error",
          message: error.response.data.error,
        },
      });
      return setTimeout(
        () => setErrors({ ...errors, response: { show: false } }),
        3000
      );
    }
  };

  const showPicker = () => {
    uploader.current.click();
  };

  const handlePickImage = async (event) => {
    const file = event.target.files[0];
    setLoadImage(true);
    const formData = new FormData();
    formData.append("file", file);

    formData.append("upload_preset", "roll_app");

    const options = {
      method: "POST",
      body: formData,
    };

    setUser({
      ...newUser,
      image: URL.createObjectURL(file),
    });

    const results = await fetch(
      `${process.env.REACT_APP_CLOUDINARY_API}/image/upload`,
      options
    );
    const response = await results.json();

    setUser({
      ...newUser,
      image: URL.createObjectURL(file),
      imageUrl: response ? response.secure_url : file,
    });
    setLoadImage(false);
  };

  // const uploadButton = (
  //   <div>
  //     {loadImage ? <Loader /> : <Icon name='plus' />}

  //     <div style={{ marginTop: 8 }}>Upload Image</div>
  //   </div>
  // );
  return (
    <Grid textAlign="center">
      <Grid.Column style={{ maxWidth: 450 }}>
        {/* <Image src={logo} centered /> */}
        {/* <Header as='h2' color='green' textAlign='center'>
          Create new account
        </Header> */}
        {errors.response.show ? (
          <Message
            error={errors.response.type === "error"}
            success={errors.response.type === "success"}
          >
            {errors.response.message}
          </Message>
        ) : null}
        <Form size="large">
          <Segment raised>
            {/* <Row>
              <Col>
                <Image
                  src='https://react.semantic-ui.com/images/wireframe/image.png'
                  className='img-fluid'
                  width={100}
                  roundedCircle
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Button size='mini'>Upload image</Button>
              </Col>
            </Row> */}
            {/* <Upload
              listType='picture-card'
              className='avatar-uploader'
              showUploadList={false}
              type='select'
              onChange={handlePickImage}
            >
              {newUser.image ? (
                <img
                  src={newUser.image}
                  alt='avatar'
                  style={{ width: "100%" }}
                />
              ) : (
                uploadButton
              )}
            </Upload> */}
            <Container>
              <Row>
                <Col>
                  <Image
                    src={!newUser.image ? `${defImage}` : newUser.image}
                    width={100}
                    roundedCircle
                    className="m-3"
                  />

                  <input
                    hidden
                    type="file"
                    ref={uploader}
                    onChange={handlePickImage}
                  />
                  <Button
                    size="tiny"
                    loading={loadImage}
                    primary={newUser.image ? true : false}
                    onClick={showPicker}
                  >
                    <Icon name="camera" />
                    {!newUser.image ? "Upload Image" : "Uploaded"}
                  </Button>
                </Col>
              </Row>
            </Container>
            <Form.Input
              fluid
              icon="user"
              iconPosition="left"
              placeholder="First Name"
              error={errors.firstName}
              onChange={(e) => {
                setUser({ ...newUser, firstName: e.target.value });
                setErrors({ ...errors, firstName: false });
              }}
            />
            <Form.Input
              fluid
              icon="user"
              iconPosition="left"
              placeholder="Last Name"
              error={errors.lastName}
              onChange={(e) => {
                setUser({ ...newUser, lastName: e.target.value });
                setErrors({ ...errors, lastName: false });
              }}
            />
            <Form.Input
              fluid
              icon="marker"
              iconPosition="left"
              placeholder="Address"
              error={errors.address}
              onChange={(e) => {
                setUser({ ...newUser, address: e.target.value });
                setErrors({ ...errors, address: false });
              }}
            />
            {/* <Form.Input
              fluid
              icon='phone'
              iconPosition='left'
              placeholder='Phone'
              error={errors.phone}
              onChange={(e) => {
                setUser({ ...newUser, phone: e.target.value });
                setErrors({ ...errors, phone: false });
              }}
            /> */}
            {/* <Form.Input
              fluid
              icon='check circle'
              iconPosition='left'
              placeholder='Confirm Password'
              type='password'
              error={
                errors.notConfirmed && newUser.password !== newUser.confirmPass
              }
              onChange={(e) =>
                setUser({ ...newUser, confirmPass: e.target.value })
              }
            /> */}

            <DatePicker
              bordered
              style={{
                width: "100%",
              }}
              onChange={(e) => setUser({ ...newUser, dob: e._d })}
            />
            <Checkbox
              label="By signing up, you agree to the Terms & Conditions"
              style={{ padding: 10 }}
              onChange={() => setChecked(!checked)}
            />
            {/* <Button
              color='green'
              fluid
              size='large'
              loading={loading}
              disabled={!checked}
              circular
              onClick={handleSignup}
            >
              Finish
            </Button> */}
            <Row className="d-flex align-items-center">
              <Col className="" lg={9}>
                <Button
                  color="dodge blue"
                  fluid
                  size="large"
                  loading={loading}
                  circular
                  disabled={!checked}
                  onClick={handleSignup}
                >
                  Finish
                </Button>
              </Col>
              <Col className="" lg={1}>
                <Button icon="arrow left" circular />
              </Col>
            </Row>
          </Segment>
        </Form>
        <Message floating>
          Already have an account? <Link to="/auth">Sign In</Link>
        </Message>
      </Grid.Column>
    </Grid>
  );
}

export default PersonalInfoForm;
